import Injectable from '@/modules/shared/domain/di/injectable';
import { CreateAddressRepository } from '../../../domain/repository/create-address-repository';

@Injectable()
export default class CreateAddressDummyRepository implements CreateAddressRepository {
  execute(): Promise<void> {
    return Promise.resolve();
  }
}
